export function cpfOuCnpjMask(valor: string): string {

    const valorInput = (valor || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

    if (/^\d{0,11}$/.test(valorInput)) {
        return maskCpf(valorInput);
    }
    
    return maskCnpj(valorInput);
}

export function maskCpf(valor: string): string {

    valor = valor.substring(0, 11);

    valor = valor.replace(/(\d{3})(\d)/, '$1.$2');
    valor = valor.replace(/(\d{3})(\d)/, '$1.$2');
    valor = valor.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

    return valor;
}

export function maskCnpj(valor: string): string {

    valor = valor.substring(0, 14);

    let base = valor.substring(0, 12);
    let dv = valor.substring(12).replace(/\D/g, '');

    let resultado = base;

    resultado = resultado.replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2');
    resultado = resultado.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3');
    resultado = resultado.replace(/\.(\w{3})(\w)/, '.$1/$2');

    if (dv.length) {
        resultado += '-' + dv;
    }

    return resultado;
}

export function limparMascara(valor: string): string {
  return (valor || '')
    .toUpperCase()
    .replace(/[^A-Z0-9 ]/g, '');
}